<div class="skeleton-header">
  <atx-skeleton-basic borderRadius="3rem"></atx-skeleton-basic>
  <atx-skeleton-basic borderRadius="3rem"></atx-skeleton-basic>
  <atx-skeleton-basic borderRadius="3rem"></atx-skeleton-basic>
  <atx-skeleton-basic borderRadius="3rem"></atx-skeleton-basic>
</div>
<atx-skeleton-basic
  class="mb-2 flex-grow-1 skeleton-content"
></atx-skeleton-basic>
<div class="skeleton-footer">
  <atx-skeleton-basic
    height="3rem"
    width="3rem"
    class="mr-2"
  ></atx-skeleton-basic>
  <atx-skeleton-basic
    height="3rem"
    width="3rem"
    class="mr-2"
  ></atx-skeleton-basic>
  <atx-skeleton-basic
    height="3rem"
    width="3rem"
    class="mr-2"
  ></atx-skeleton-basic>
  <atx-skeleton-basic height="3rem" width="3rem"></atx-skeleton-basic>
</div>
